export default "__VITE_ASSET__Du5dN$ta__"